import React, { useState } from "react";
import styled, { css } from "styled-components";

import { FaBookOpen, FaHome, FaPencilAlt, FaRegFileAlt, FaTags } from "react-icons/fa";
import { IconType } from "react-icons/lib/esm/iconBase";
import colors from "../../../../../styles/colors";
import { CourseInstructionType, ICourseInstruction } from "../../../../course-author/types";

interface IStyledButtonProps {
  alternateColor: boolean;
  shouldDisplay: boolean;
}

const StyledButton = styled.button<IStyledButtonProps>`
  align-items: center;
  background: ${props =>
    props.shouldDisplay ? (props.alternateColor ? colors.highlightLightBlue : colors.highlightLightGrey) : "inherit"};
  border: none;
  cursor: pointer;
  display: flex;
  height: 5rem;
  justify-content: space-around;
  margin-bottom: 0;
  width: 20rem;
  color: inherit;
  border-right: 0.1rem solid ${colors.lightgrey2};
  ${props =>
    props.shouldDisplay &&
    css`
      box-shadow: 0rem 0rem 0.25rem rgba(0, 0, 0, 0.25);
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
    `}
  &:focus {
    outline: none;
  }
  &:hover {
    box-shadow: 0rem 0rem 0.25rem rgba(0, 0, 0, 0.25);
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
`;

const ItemCountDiv = styled.div<{ fade: boolean }>`
  opacity: ${props => (props.fade ? "0.33" : "1")};
`;

interface IItemCountProps {
  count: number;
  Icon: IconType;
}

const ItemCount: React.SFC<IItemCountProps> = props => (
  <ItemCountDiv fade={props.count === 0}>
    <props.Icon />
    {props.count}
  </ItemCountDiv>
);

interface IUnitContentDropDownButtonProps {
  alternateColor: boolean;
  display?: boolean;
  onClick: () => void;
  numQuestions: number;
  instructionalMaterial: {
    [type in CourseInstructionType]: ICourseInstruction[];
  };
}

export const UnitContentDropDownButton: React.FC<IUnitContentDropDownButtonProps> = props => {
  const [display, setDisplay] = useState<boolean>(props.display || false);

  const buttonClicked = () => {
    setDisplay(!display);
    props.onClick();
  };

  return (
    <StyledButton alternateColor={props.alternateColor} shouldDisplay={display} onClick={buttonClicked}>
      <ItemCount Icon={FaPencilAlt} count={props.numQuestions} />
      <ItemCount Icon={FaHome} count={props.instructionalMaterial[CourseInstructionType.Introduction].length} />
      <ItemCount Icon={FaBookOpen} count={props.instructionalMaterial[CourseInstructionType.Lesson].length} />
      <ItemCount Icon={FaRegFileAlt} count={props.instructionalMaterial[CourseInstructionType.Summary].length} />
      <ItemCount Icon={FaTags} count={props.instructionalMaterial[CourseInstructionType.Appendix].length} />
    </StyledButton>
  );
};
